interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "center",
}: SectionHeadingProps) {
  const centered = align === "center";
  return (
    <div className={`${centered ? "mx-auto text-center" : ""} max-w-2xl`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1 text-xs font-bold tracking-wide text-secondary-900">
        <i className="ri-price-tag-3-line" />
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc ? (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
      ) : null}
    </div>
  );
}